/**
 * defaultProposalTemplate.ts — Modelo padrão da proposta pública
 *
 * Reproduz, em blocos do Studio, exatamente a landing pública que já existe em
 * `/p/:token`. É usado quando a proposta não tem modelo próprio escolhido,
 * garantindo que o caminho antigo e o novo entreguem a mesma tela.
 *
 * RELEASE: v1.0.0 - 2026-09-09 - Versão inicial (Studio, Fase 2)
 */

import { STUDIO_SCHEMA_VERSION, type StudioDocument } from '@/lib/studio/core';

/** Documento padrão da proposta web (mesma ordem visual da tela atual). */
export const DEFAULT_PROPOSAL_DOCUMENT: StudioDocument = {
  schemaVersion: STUDIO_SCHEMA_VERSION,
  theme: {},
  settings: { stickyBar: true },
  blocks: [
    { id: 'hero', type: 'proposal.hero', props: {} },
    { id: 'status', type: 'proposal.status', props: {} },
    { id: 'items', type: 'proposal.items', props: {} },
    { id: 'totals', type: 'proposal.totals', props: {} },
    { id: 'conditions', type: 'proposal.conditions', props: {} },
    { id: 'decision', type: 'action.proposal.decision', props: {} },
    { id: 'footer', type: 'proposal.footer', props: {} },
  ],
};
